{
  "common": {
    "cancel": "Cancelar",
    "delete": "Excluir",
    "save": "Salvar"
  },
  "fieldTypes": {
    "text": "Texto curto",
    "textarea": "Texto longo",
    "select": "Seleção única",
    "multiselect": "Seleção múltipla",
    "date": "Data",
    "number": "Número",
    "url": "URL",
    "boolean": "Sim/Não"
  },
  "sections": {
    "personal": "Dados Pessoais",
    "address": "Endereço",
    "social": "Redes Sociais",
    "custom": "Informações Adicionais"
  },
  "page": {
    "title": "Campos do Perfil",
    "subtitle": "Configure os campos que os membros preenchem no perfil",
    "hidePreview": "Ocultar",
    "showPreview": "Preview",
    "newField": "Novo Campo",
    "deleteSuccess": "Campo excluído",
    "deleteError": "Erro ao excluir campo",
    "toggleError": "Erro ao alterar campo",
    "empty": {
      "title": "Nenhum campo customizado",
      "description": "Crie campos personalizados que os membros preenchem no perfil",
      "create": "Criar primeiro campo"
    },
    "deleteDialog": {
      "title": "Excluir campo",
      "description": "Tem certeza que deseja excluir o campo <bold>{{label}}</bold>? Todos os valores preenchidos pelos membros serão perdidos."
    }
  },
  "preview": {
    "title": "Preview do perfil — como o membro vê",
    "fixed": "fixo",
    "custom": "customizado",
    "selectPlaceholder": "Selecione",
    "personalDescription": "Preencha seus principais dados",
    "fields": {
      "fullName": "Nome completo",
      "fullNamePlaceholder": "Seu nome completo",
      "email": "Email",
      "emailPlaceholder": "email@exemplo.com",
      "cpf": "CPF",
      "phone": "Celular/WhatsApp",
      "birthDate": "Data de nascimento",
      "birthDatePlaceholder": "DD/MM/AAAA",
      "occupation": "Ocupação",
      "occupationPlaceholder": "Ex: Desenvolvedor Full Stack",
      "bio": "Bio",
      "bioPlaceholder": "Fale um pouco sobre você...",
      "zipCode": "CEP",
      "state": "Estado",
      "statePlaceholder": "SP",
      "city": "Cidade",
      "cityPlaceholder": "São Paulo",
      "neighborhood": "Bairro",
      "neighborhoodPlaceholder": "Bairro",
      "street": "Rua",
      "streetPlaceholder": "Rua, Avenida...",
      "number": "Número",
      "usernamePlaceholder": "@seuusuario"
    }
  },
  "row": {
    "required": "obrigatório",
    "optionsCount_one": "{{count}} opção",
    "optionsCount_zero": "{{count}} opções",
    "optionsCount_other": "{{count}} opções",
    "deactivate": "Desativar",
    "activate": "Ativar",
    "edit": "Editar",
    "delete": "Excluir"
  },
  "dialog": {
    "labelRequired": "Nome do campo é obrigatório",
    "updated": "Campo atualizado",
    "created": "Campo criado",
    "saveError": "Erro ao salvar campo",
    "editTitle": "Editar Campo",
    "newTitle": "Novo Campo",
    "label": "Nome do campo *",
    "labelPlaceholder": "Ex: Experiência profissional",
    "type": "Tipo",
    "section": "Seção",
    "options": "Opções (separadas por vírgula)",
    "optionsPlaceholder": "Opção A, Opção B, Opção C",
    "placeholder": "Placeholder",
    "placeholderPlaceholder": "Texto de ajuda dentro do campo",
    "helpText": "Texto de ajuda (opcional)",
    "helpTextPlaceholder": "Descrição que aparece abaixo do campo",
    "required": "Campo obrigatório",
    "create": "Criar Campo"
  }
}
